<div class="ui-g loyality-acm">


  <div class="ui-g-12" *ngIf="columsTitles && acmPermission">
    <app-kontable title = "{{ 'customers.accumulators' | translate }}" #table
                  [columns] = "[
                  { field: 'channel_id', filterType: selectFilter, title: 'acm.channel_id', filterOptions: {values: listChannelsSelect},bodyTemplate: channelDescriptionTemplate},
                  'acm_code', 'acmDescription',
                  { field: 'acmTypeDescription',filterType: selectFilter, title: 'acm.acm_type_id', filterOptions: {values: listAcmTypes}},
                  { field: 'status', title: 'common.validity', filterType: selectFilter, bodyTemplate: activationStateTemplate, filterTemplate: activationStateTemplateFilter, filterOptions: {values: listActivationStates}},
                  { field: 'flg_state', title: 'common.status', bodyTemplate: stateTemplate, filterType: selectFilter, filterTemplate: customerStateFilter, filterOptions: {values: listStates}},
                  { field: 'dateStart', title:  'acm.date_start', filterType: customFilter, filterTemplate: dateStartFilter},
                  { field: 'dateEnd', title:  'acm.date_end', filterType: customFilter, filterTemplate: dateEndFilter}

                  ]"
                  [titles] = "['acm.acm_code', 'acm.description', 'acm.status']"
                  [showInfoButton]="true"
                  [showDetailsButton]="false"
                  [showAddButton]="true"
                  [service]="acmService"
                  [paginationType]="paginationType"
                  [servicePermissions]="acmPermission"
                  [(fireNewDataAvailable)]="newDataAvailable"
                  (onRecover)="recover($event)"
                  (onAdd)="add($event)"
                  (onEdit)="edit($event)"
                  (onRemove)="remove($event)">

      <ng-template #dateStartFilter data-testid="dateStartFilter" let-col>
        <span></span>
      </ng-template>


      <ng-template #dateEndFilter data-testid="dateEndFilter" let-col>
        <span></span>
      </ng-template>


      <ng-template #channelDescriptionTemplate data-testid="channelDescriptionTemplate" let-col>
        <span>{{col.channelDescription}}</span>
      </ng-template>

      <ng-template #pAcmTypeTemplateFilter data-testid="pAcmTypeTemplateFilter" let-col>
        <p-dropdown [options]="listAcmTypes"  [style]="{'width':'100%'}"  (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')" ></p-dropdown>
      </ng-template>

      <ng-template #pChannelTemplateFilter data-testid="pChannelTemplateFilter" let-col>
        <p-dropdown [options]="listChannelsSelect" (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')" ></p-dropdown>
      </ng-template>

      <ng-template #activationStateTemplateFilter data-testid="activationStateTemplateFilter" let-col>
        <p-dropdown [options]="listActivationStates" (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')" ></p-dropdown>
      </ng-template>

      <ng-template #stateTemplate data-testid="stateTemplate" let-row class="deleted-row">
          <span *ngIf="row.flg_state && row.flg_state == '1'" class="fa fa-trash-o" title="{{'common.deleted' | translate}}"></span>
          <span *ngIf="row.flg_state && row.flg_state == '2'" class="fa fa-ban" title="{{'common.suspended' | translate}}"></span>
      </ng-template>



      <ng-template #activationStateTemplate data-testid="activationStateTemplate" let-row>
        <span *ngIf="getStatus(row) == 'expired'"> {{ 'acm.expired' | translate }}</span>
        <span *ngIf="getStatus(row) == 'valid'"> {{ 'acm.valid' | translate }}</span>
        <span *ngIf="getStatus(row) == 'future'"> {{ 'acm.future' | translate }}</span>
      </ng-template>


      <ng-template #customerStateFilter data-testid="customerStateFilter" let-col>
          <p-dropdown [options]="listStates" [style]="{'width':'100%'}" (onChange)="table.updateTableFilter(col.field, $event.value, 'equals')"></p-dropdown>
      </ng-template>

    </app-kontable>
  </div>

</div>




// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-acm/loyalty-acm.component.html